var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedAlertError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_2843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 1.5H55.625C55.625 1.5 58.125 1.5 58.125 4V44C58.125 44 58.125 46.5 55.625 46.5H4.375C4.375 46.5 1.875 46.5 1.875 44V4C1.875 4 1.875 1.5 4.375 1.5Z",
    fill: "#FF978C",
    fillOpacity: 0.5,
    stroke: "#C12010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 13.5V25.5",
    stroke: "#C12010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 33C28.125 33.3978 28.3225 33.7794 28.6742 34.0607C29.0258 34.342 29.5027 34.5 30 34.5C30.4973 34.5 30.9742 34.342 31.3258 34.0607C31.6775 33.7794 31.875 33.3978 31.875 33C31.875 32.6022 31.6775 32.2206 31.3258 31.9393C30.9742 31.658 30.4973 31.5 30 31.5C29.5027 31.5 29.0258 31.658 28.6742 31.9393C28.3225 32.2206 28.125 32.6022 28.125 33Z",
    fill: "#C12010",
    stroke: "#C12010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_2843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlertError);
export default __webpack_public_path__ + "static/media/red-alert-error.a981d8430176610b101d8088256a899a.svg";
export { ForwardRef as ReactComponent };